import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FormFieldBase} from '../models/form-field-base';


@Injectable({
  providedIn: 'root',
})
export class FormFieldControlService {

  public toFormGroup(formFields: FormFieldBase[], form?: FormGroup) {
    let controls = {};

    formFields.forEach(it => {
      if (form == null) {
        controls[it.key] = this.toFormControl(it);
      } else {
        form.addControl(it.key, this.toFormControl(it));
      }
    })

    if(form) {
      return form;
    }
    else {
      return new FormGroup(controls);
    }
  }

  public toFormControl(formField: FormFieldBase) {
    return new FormControl({ value: formField.value || null, disabled: formField.disabled }, {
      validators: this.toValidators(formField)
    });

    // return formField.required
    //   ? new FormControl({value: formField.value || null, disabled: formField.disabled}, Validators.required )
    //   : new FormControl({value: formField.value || null, disabled: formField.disabled})
  }

  private toValidators(formField: FormFieldBase) {
    let validators = [];
    if (formField.required) {
      validators.push(Validators.required);
    }
    if (formField.pattern) {
      validators.push(Validators.pattern(formField.pattern));
    }
    return validators
  }
}
